import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Landmark } from "lucide-react";
import RichTextView from "@/components/app/RichTextView";

const DEFAULT_HISTORY = `<p>Salford Town Hall is a landmark of civic heritage, standing proudly at the heart of the city for over a century. Originally built to house the civic affairs of the borough, the building has been thoughtfully restored and converted into a residential community that retains the grandeur of its Victorian architecture.</p>
<p>Residents and leaseholders today enjoy a home that is both historically significant and warmly welcoming — a rare blend of heritage detail and modern comfort.</p>
<p><em>An administrator can update this page from the Administration area at any time.</em></p>`;

export default function History() {
  const [data, setData] = useState({ title: "", body: "", updated_at: "" });

  useEffect(() => {
    api.get("/history").then((r) => setData(r.data || {}));
  }, []);

  const title = data.title || "The History of Salford Town Hall";
  const body = data.body || DEFAULT_HISTORY;
  const updated = data.updated_at
    ? new Date(data.updated_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })
    : "";

  return (
    <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6 lg:px-8">
      <header className="mb-8 flex items-start gap-3">
        <div className="rounded-2xl bg-amber-50 p-3 ring-1 ring-amber-100">
          <Landmark className="h-6 w-6 text-amber-800" />
        </div>
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-amber-800">Our Building</div>
          <h1 className="mt-1 font-serif text-4xl font-semibold text-stone-900 sm:text-5xl">{title}</h1>
          {updated && <p className="mt-2 text-sm text-stone-500">Last updated {updated}</p>}
        </div>
      </header>

      <article className="rounded-3xl border border-stone-200 bg-white p-6 sm:p-10 shadow-sm">
        <RichTextView html={body} className="text-lg" />
      </article>
    </div>
  );
}
